import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { generateColorGradient } from "../../../../Components/Hooks/useColorArrayHooks";
import BarChart from "../../../../Components/Common/Charts/BarChart";
import { getGuidesInfoByEstablishmenteType, getGuidesInfoByFinalDestination } from "../../../../slices/thunks";
import { createSelector } from "reselect";
import OPlaceholder from "../../../../Components/OElements/OPlaceholder";
import CardWithError from "../../../../Components/Common/CardWithError";
import CardWithoutData from "../../../../Components/Common/CardWithoutData";



const MortalityTypeInfo = ({ title, height }) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.ResidueDashboard,
        result => ({
            data: result.infoFinalDestination,
            isLoading: result.isLoading,
            isSuccess: result.isSuccess,
            isError: result.isError,
        })
    );

    const { data, isLoading, isSuccess, isError } = useSelector(selector);

    useEffect(() => {
        dispatch(getGuidesInfoByFinalDestination());
    }, []);


    const lengthChart = data?.detail?.length || 0;
    const seriesChart = [{ name: 'Toneladas', data: data?.detail?.map(item => item.total) || [] }];
    const labelsChart = data?.detail?.map(item => item.name) || [];
    const colorsChart = generateColorGradient(lengthChart);


    if (isLoading) {
        return <OPlaceholder />;
    }

    if (isError) {
        return <CardWithError title={title} />;
    }

    if (isSuccess && data) {
        return (
            <React.Fragment>
                <Card className='card-height-100'>
                    <CardHeader className='p-2 align-items-center d-flex'>
                        <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
                        <div className='btn-box-dashboard'>
                            <Button color="secondary" size="sm" className="btn-soft-secondary me-1">
                                Todo
                            </Button>
                            <Button color="primary" size="sm" className="btn-soft-primary me-1">
                                1A
                            </Button>
                            <Button color="secondary" size="sm" className="btn-soft-secondary">
                                1M
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0 pb-2">
                        <div className="w-100">
                            <div dir="ltr">
                                <BarChart
                                    seriesChart={seriesChart}
                                    categoriesChart={labelsChart}
                                    colorsChart={colorsChart}
                                    height={height}
                                    toolbarChart={false}
                                    legendPosition={'bottom'}
                                    legendOffsetY={2}
                                    strokeCurve={'smooth'}
                                    chartType={'bar'}
                                    horizontal={true}
                                />
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }

    return <CardWithoutData title={title} />;

};

export default MortalityTypeInfo;
